import { colors } from "widgets/utils";

import { useGenomeViewerStore } from "../../store/store.ts";

export function rangeZoomRenderer() {
  const { ctx, zoomRange: zoomRegion } = useGenomeViewerStore.getState();

  if (ctx && zoomRegion) {
    ctx.save();

    ctx.fillStyle = colors.warningPale;
    ctx.strokeStyle = colors.warningLight;
    ctx.globalAlpha = 0.5;
    ctx.fillRect(zoomRegion.startX, 0, zoomRegion.stopX - zoomRegion.startX, ctx.canvas.height);
    ctx.strokeRect(zoomRegion.startX, 0, zoomRegion.stopX - zoomRegion.startX, ctx.canvas.height);

    ctx.restore();
  }
}
